import React from 'react';
import ImageLoader from 'react-load-image';
import Icon from '../../svg/image-preloader.svg';

export interface IPreloadImage {
    src: string;
    alt?: string;
    wrapperClassName?: string;
    imgClassName?: string;
}

const PreloadImage: React.StatelessComponent<IPreloadImage> = ({ src, imgClassName, wrapperClassName }) => {
    return (
        <ImageLoader src={src} className={wrapperClassName}>
            <img className={imgClassName} />
            <div className={imgClassName}>Здесь будет картинка</div>
            <Icon />
        </ImageLoader>
    );
};

export default PreloadImage;
